module.exports = __webpack_public_path__ + "img/_weapon_potion_05.48d39344.png";